import styled from 'styled-components'

export const StyledSidebar = styled.div`
  min-width: 104px;
  width: 104px;
`
export const SidebarWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: ${(props) => {
    return props.isExpanded ? '200px' : '104px'
  }};
  min-width: ${(props) => {
    return props.isExpanded ? '200px' : '104px'
  }};
  z-index: 10;
  background: #FFF;
  box-shadow: 1px 0 4px rgb(32 32 32 / 10%);
`

export const SidebarItem = styled.div`
  height: 56px;
  display: flex;
  align-items: center;
  cursor: pointer;
  padding-left: 40px;

  background-color: ${(props) => {
    return props.isActive ? 'rgba(10, 161, 244, 0.05);' : 'transparent'
  }};
  border-left: ${(props) => {
    return props.isActive ? '2px solid #0AA1F4' : '2px solid rgba(255, 255, 255, 1)'
  }};

  &:hover span {
    color: ${(p) => {
    return p.isActive ? 'rgba(32, 32, 32, 1)' : '#0aa1f4'
  }};
  }

  &:hover svg path {
    fill: ${(p) => {
    return p.isActive ? 'rgba(32, 32, 32, 1)' : '#0aa1f4'
  }};
  }
`
export const MenuIconWrapper = styled.div`
  background-color: transparent;
  border-radius: 20px;
  height: 40px;
  width: 40px;
  cursor: pointer;
  display: grid;
  place-items: center;  

  &:hover {
    background-color: rgba(32, 32, 32, 0.05);
  }
`

export const SidebarItemText = styled.span`
  display: ${(props) => {
    return props.isExpanded ? 'inline-block' : 'none'
  }};
  margin-left: 20px;
`

export const SidebarArrowIconWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 30px;
  display: grid;
  place-items: center;
  cursor: pointer;  
  margin-right: 16px;

  :hover {
    background-color: rgba(32, 32, 32, 0.05);
  }

  &:hover svg path {
    fill-opacity: 1;
  }
`
export const SidebarExpandedHeader = styled.div`
  display: flex;
  padding-left: 40px;
  align-items: center;
  justify-content: space-between;
`
export const SidebarHeaderWrapper = styled.div`
  margin-bottom: 76px;
  padding-top: 20px;
  height: 40px;
  margin-left: ${(props) => {
    return props.isExpanded ? '' : '4px'
  }}
`
